export default __webpack_public_path__ + "static/zeiten-im-wandel-c393cbe82cf0a172a9a4b9f6c367325f.svg";